/* eslint-disable @typescript-eslint/no-explicit-any */
import * as yup from 'yup';

export type ConditionalSchema<T> = T extends string
  ? yup.StringSchema
  : T extends number
    ? yup.NumberSchema
    : T extends boolean
      ? yup.BooleanSchema
      : T extends Record<any, any>
        ? yup.AnyObjectSchema
        : T extends Array<any>
          ? yup.ArraySchema<any, any>
          : yup.AnySchema;

export type Shape<Fields> = {
  [Key in keyof Fields]: ConditionalSchema<Fields[Key]>;
};

export enum EditMode {
  Create = 'Create',
  Edit = 'Edit',
}

export type Option = {
  value: string;
  label: string;
};

export enum NotificationStatus {
  UnRead = 'UnRead',
  Read = 'Read',
  InitiateTask = 'InitiateTask',
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
}

/**
 * 频率类型枚举
 */
export enum FrequencyType {
  Yearly = 'Yearly',
  Quarterly = 'Quarterly',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

/**
 * 频率类型中文映射
 */
export const FrequencyTypeMap: Record<FrequencyType, string> = {
  [FrequencyType.Yearly]: '年度',
  [FrequencyType.Quarterly]: '季度',
  [FrequencyType.Monthly]: '月度',
  [FrequencyType.Weekly]: '周度'
};

/**
 * 报表类型映射
 */
export const ReportTypeMap: Record<FrequencyType, string> = {
  [FrequencyType.Yearly]: '年报表',
  [FrequencyType.Quarterly]: '季度报表',
  [FrequencyType.Monthly]: '月报表',
  [FrequencyType.Weekly]: '周报表'
};

/**
 * 频率类型对应的目标文本映射
 */
export const FrequencyTypeToObjective: Record<FrequencyType, string> = {
  [FrequencyType.Yearly]: "年度目标",
  [FrequencyType.Quarterly]: "季度目标",
  [FrequencyType.Monthly]: "月度目标",
  [FrequencyType.Weekly]: "周目标"
};

/**
 * 频率类型对应的报表文本映射
 */
export const FrequencyTypeToReport: Record<FrequencyType, string> = {
  [FrequencyType.Yearly]: "年度报表",
  [FrequencyType.Quarterly]: "季度报表",
  [FrequencyType.Monthly]: "月度报表",
  [FrequencyType.Weekly]: "周报表"
};

/**
 * 获取频率类型的标签文本
 * @param type 频率类型
 * @returns 对应的标签文本
 */
export function getFrequencyLabel(type: string): string {
  if (type === FrequencyType.Yearly) return '';
  if (type === FrequencyType.Quarterly) return '季度';
  if (type === FrequencyType.Monthly) return '月';
  if (type === FrequencyType.Weekly) return '周';
  return '';
}
